import { Children, cloneElement, Component, isValidElement } from 'react';
import { Status } from '@optimus-web/common';
import { FormMessage } from '../common/FormMessage';
import { FormLabel } from '../commonStyle';
import { RadioButton } from '../RadioButton';
import { isComponentOfType } from '../utils/isComponentOfType';
import { RadioGroupProps } from './RadioGroupProps';
import { RadioButtonGroupContainer, RadioGroupElement } from './style';

type ChildProps = RadioGroupProps & {
    checked?: boolean;
    'data-test-radio'?: RadioGroupProps['value'];
};

export default class RadioGroup extends Component<RadioGroupProps> {
    render() {
        const { className, disabled, children, value, label, error, required, ...other } = this.props;

        return (
            <RadioGroupElement className={className}>
                {label ? (
                    <FormLabel required={required} as="legend">
                        {label}
                    </FormLabel>
                ) : null}
                <RadioButtonGroupContainer>
                    {Children.map(children, (child) =>
                        isValidElement<ChildProps>(child) && isComponentOfTypeRadioButton(child)
                            ? cloneElement(child, {
                                  ...other,
                                  checked: child.props.value === value,
                                  disabled: disabled || child.props.disabled,
                                  'data-test-radio': child.props.value,
                              })
                            : child
                    )}
                </RadioButtonGroupContainer>
                {error ? (
                    <FormMessage status={Status.Error} id={`${value}-error`}>
                        {error}
                    </FormMessage>
                ) : null}
            </RadioGroupElement>
        );
    }
}

const isComponentOfTypeRadioButton = isComponentOfType(RadioButton);
